<template>
  <div class="titlebarstyle">
    <el-form
      label-width="90px"
      :model="datas"
      size="small"
      class="lef"
      style="margin-top: 20px"
    >
      <!-- 模块名称 -->
      <el-form-item label="模块名称：">
        <div class="weiz">
          <div class="ml35">
            <el-input disabled v-model="datas.moduleName"> </el-input>
          </div>
        </div>
      </el-form-item>

      <!-- 标题文本 -->
      <el-form-item label="标题文本：">
        <div class="weiz">
          <div class="ml35">
            <el-input placeholder="请输入标题文本" v-model="datas.text">
            </el-input>
          </div>
        </div>
      </el-form-item>
      <!-- 内边距设置 -->
      <!-- <el-form-item label="内边距：">
        <div class="weiz">
          <div class="ml35 padding-container">
            <div class="padding-item">
              <span class="padding-label">上</span>
              <el-input-number
                v-model="datas.paddingTop"
                :min="0"
                :max="100"
                :step="1"
                style="width: 80px"
              ></el-input-number>
              <span class="padding-unit">px</span>
            </div>
            <div class="padding-item">
              <span class="padding-label">下</span>
              <el-input-number
                v-model="datas.paddingBottom"
                :min="0"
                :max="100"
                :step="1"
                style="width: 80px"
              ></el-input-number>
              <span class="padding-unit">px</span>
            </div>
            <div class="padding-item">
              <span class="padding-label">左</span>
              <el-input-number
                v-model="datas.paddingLeft"
                :min="0"
                :max="100"
                :step="1"
                style="width: 80px"
              ></el-input-number>
              <span class="padding-unit">px</span>
            </div>
            <div class="padding-item">
              <span class="padding-label">右</span>
              <el-input-number
                v-model="datas.paddingRight"
                :min="0"
                :max="100"
                :step="1"
                style="width: 80px"
              ></el-input-number>
              <span class="padding-unit">px</span>
            </div>
          </div>
        </div>
      </el-form-item> -->

      <!-- 背景颜色 -->
      <!-- <el-form-item class="lef" label="背景：">
        <div class="weiz">
          <div class="ml35">
            <LinkInput :datas="datas" field="lineColor" type="color" />
          </div>
        </div>
      </el-form-item> -->

      <!-- 左侧竖线配置 -->
      <el-form-item label="显示竖线：">
        <div class="weiz">
          <div class="ml35">
            <el-switch
              v-model="datas.showLine"
              active-color="#13ce66"
              inactive-color="#ff4949"
            ></el-switch>
          </div>
        </div>
      </el-form-item>
      <!-- <el-form-item v-if="datas.showLine" label="竖线宽度：">
        <div class="weiz">
          <div class="ml35">
            <el-input-number
              v-model="datas.lineWidth"
              :min="1"
              :max="20"
              :step="1"
              style="width: 120px"
            ></el-input-number>
            <span class="padding-unit">px</span>
          </div>
        </div>
      </el-form-item> -->
      <el-form-item v-if="datas.showLine" label="竖线颜色：">
        <div class="weiz">
          <div class="ml35">
            <!--背景颜色子组件 -->
            <LinkInput
              :datas="datas"
              field="lineColor"
              defaultColor="defaultLineColor"
              type="color"
            />
          </div>
        </div>
      </el-form-item>
      <!-- <el-form-item v-if="datas.showLine" label="竖线右边距：">
        <div class="weiz">
          <div class="ml35">
            <el-input-number
              v-model="datas.lineMarginRight"
              :min="0"
              :max="50"
              :step="1"
              style="width: 120px"
            ></el-input-number>
            <span class="padding-unit">px</span>
          </div>
        </div>
      </el-form-item> -->
      <!-- 图标类型 -->
      <!-- <el-form-item label="图标类型：">
        <div class="weiz">
          <div class="ml35">
            <el-select v-model="datas.iconType" placeholder="请选择图标类型">
              <el-option label="无" value=""></el-option>
              <el-option label="竖线" value="line"></el-option>
              <el-option label="图片" value="image"></el-option>
            </el-select>
          </div>
        </div>
      </el-form-item> -->
      <!-- 图标配置 -->
      <!-- <el-form-item v-if="datas.iconType === 'image'" label="图标/图片：">
        <div class="weiz">
          <div class="ml35">
            <el-input
              placeholder="请输入图标名称或图片地址"
              v-model="datas.image"
            >
            </el-input>
          </div>
        </div>
      </el-form-item>

      <el-form-item v-if="datas.iconType === 'image'" label="图标大小：">
        <div class="weiz">
          <div class="ml35">
            <el-input-number
              v-model="datas.iconSize"
              :min="12"
              :max="50"
              :step="1"
              style="width: 120px"
            ></el-input-number>
            <span class="padding-unit">px</span>
          </div>
        </div>
      </el-form-item>

      <el-form-item v-if="datas.iconType === 'image'" label="图片宽度：">
        <div class="weiz">
          <div class="ml35">
            <el-input-number
              v-model="datas.iconWidth"
              :min="10"
              :max="100"
              :step="1"
              style="width: 120px"
            ></el-input-number>
            <span class="padding-unit">px</span>
          </div>
        </div>
      </el-form-item>

      <el-form-item v-if="datas.iconType === 'image'" label="图片高度：">
        <div class="weiz">
          <div class="ml35">
            <el-input-number
              v-model="datas.iconHeight"
              :min="10"
              :max="100"
              :step="1"
              style="width: 120px"
            ></el-input-number>
            <span class="padding-unit">px</span>
          </div>
        </div>
      </el-form-item>

      <el-form-item v-if="datas.iconType === 'image'" label="图标颜色：">
        <div class="weiz">
          <div class="ml35">
            <el-color-picker
              v-model="datas.iconColor"
              show-alpha
              @change="handleCustomColorChange($event, 'iconColor')"
            ></el-color-picker>
            <el-input
              placeholder="请输入图标颜色"
              v-model="datas.iconColor"
              style="margin-left: 10px"
            >
            </el-input>
          </div>
        </div>
      </el-form-item>

      <el-form-item v-if="datas.iconType === 'image'" label="图标右边距：">
        <div class="weiz">
          <div class="ml35">
            <el-input-number
              v-model="datas.iconMarginRight"
              :min="0"
              :max="50"
              :step="1"
              style="width: 120px"
            ></el-input-number>
            <span class="padding-unit">px</span>
          </div>
        </div>
      </el-form-item> -->

      <!-- 文本样式 -->
      <el-form-item label="文本颜色：">
        <div class="weiz">
          <div class="ml35">
            <LinkInput
              :datas="datas"
              field="textColor"
              defaultColor="defaultTextColor"
              type="color"
            />
          </div>
        </div>
      </el-form-item>
      <el-form-item
        label="字号："
        prop="wordSize"
        :hide-required-asterisk="true"
      >
        <div class="weiz">
          <div class="ml35">
            <el-select v-model="datas.textSize" placeholder="请选择字号">
              <el-option
                v-for="item in wordSizeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
      </el-form-item>
      <!-- 

      <el-form-item label="字体粗细：">
        <div class="weiz">
          <div class="ml35">
            <el-select v-model="datas.fontWeight" placeholder="请选择字体粗细">
              <el-option label="正常" value="normal"></el-option>
              <el-option label="加粗" value="bold"></el-option>
              <el-option label="100" value="100"></el-option>
              <el-option label="200" value="200"></el-option>
              <el-option label="300" value="300"></el-option>
              <el-option label="400" value="400"></el-option>
              <el-option label="500" value="500"></el-option>
              <el-option label="600" value="600"></el-option>
              <el-option label="700" value="700"></el-option>
              <el-option label="800" value="800"></el-option>
              <el-option label="900" value="900"></el-option>
            </el-select>
          </div>
        </div>
      </el-form-item> -->
    </el-form>
  </div>
</template>

<script>
import {
  wordSizeOptions,
  fontFamilyOptions,
  predefineColors,
} from "@/utils/defaultData.js";
export default {
  name: "titlebarstyle",
  props: {
    datas: Object,
  },
  data() {
    return {};
  },
  methods: {
    // 处理自定义颜色变化
    handleCustomColorChange(color, type) {
      console.log("颜色选择事件", color, type);
      this.datas[type] = color;
    },
  },
  created() {
    console.log("标题栏样式组件挂载", this.datas);
  },
};
</script>

<style scoped lang="scss">
.titlebarstyle {
  width: 100%;
  left: 0;
  top: 0;
  padding: 0 10px 20px;
  box-sizing: border-box;

  /* 标题 */
  h2 {
    padding: 24px 16px 24px 0;
    margin-bottom: 15px;
    border-bottom: 1px solid #f2f4f6;
    font-size: 18px;
    font-weight: 600;
    color: #323233;
  }

  .lef {
    ::v-deep.el-form-item__label {
      text-align: left;
    }
  }

  .padding-container {
    display: flex;
    gap: 15px;
    flex-direction: column;
    .padding-item {
      display: flex;
      align-items: center;
      gap: 5px;
    }
  }

  .ml35 {
    margin-left: 35px;
  }
}
</style>
